// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'list';

export const Component = () => (
  <path d='M4.56 6.058a1.466 1.466 0 0 1-1.06.439 1.46 1.46 0 0 1-1.06-.439A1.463 1.463 0 0 1 2 4.998c0-.402.146-.767.44-1.06A1.466 1.466 0 0 1 3.5 3.5c.403 0 .768.146 1.06.439.293.292.44.657.44 1.06 0 .402-.146.766-.44 1.06Zm0 7.503a1.466 1.466 0 0 1-1.06.438c-.403 0-.768-.146-1.06-.438A1.463 1.463 0 0 1 2 12.5c0-.402.146-.767.44-1.06a1.466 1.466 0 0 1 1.06-.438c.403 0 .768.146 1.06.438.293.292.44.658.44 1.06s-.146.767-.44 1.06Zm0 7.501a1.466 1.466 0 0 1-1.06.44 1.46 1.46 0 0 1-1.06-.44 1.463 1.463 0 0 1-.44-1.06c0-.402.146-.766.44-1.059a1.466 1.466 0 0 1 1.06-.439c.403 0 .768.146 1.06.439.293.292.44.657.44 1.06 0 .402-.146.767-.44 1.06ZM8 4.5h15v1.885H8V4.5Zm0 7.08h15v1.84H8v-1.84Zm0 7.035h15V20.5H8v-1.885Z' />
);

export const viewBox = '0 0 25 25';
